import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import getDataIconAttribute from '../../helpers/getDataIconAttribute';
import s from '../../IconV2.scss';

const TwitterOutlined24: FC<IconV2Props> = ({ icon, chroma }) => (
  <svg
    className={cn(s.svg24, `svg-icon--${icon}`)}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    data-icon={getDataIconAttribute(chroma, icon, '24')}
  >
    <path
      className={cn(
        chroma === 'default' && s.twitterFill,
        chroma === 'dark' && s.lightFill,
        chroma === 'light' && s.darkFill
      )}
      d="M12.5 1C18.847 1 24 6.153 24 12.5S18.847 24 12.5 24 1 18.847 1 12.5 6.153 1 12.5 1zm0 1.198C6.815 2.198 2.198 6.815 2.198 12.5S6.815 22.802 12.5 22.802 22.802 18.185 22.802 12.5 18.185 2.198 12.5 2.198zm2.15 5.638c.65 0 1.239.292 1.652.73.53-.088 1.002-.292 1.444-.555-.177.525-.53.962-.914 1.312.443-.029.885-.175 1.298-.35a4.357 4.357 0 01-1.12 1.196v.291c0 3.033-2.3 6.532-6.457 6.532a6.4 6.4 0 01-3.48-1.02c.177.029.354.029.531.029a4.482 4.482 0 002.801-.991 2.309 2.309 0 01-2.123-1.604c.118.029.266.029.413.029.206 0 .413-.03.59-.088a2.266 2.266 0 01-1.828-2.245v-.03c.324.176.648.292 1.032.292-.59-.437-1.003-1.137-1.003-1.924 0-.438.089-.816.295-1.166 1.12 1.37 2.771 2.303 4.658 2.39a3.175 3.175 0 01-.059-.524c0-1.283 1.032-2.304 2.27-2.304z"
      fillRule="evenodd"
    />
  </svg>
);

export default TwitterOutlined24;
